import type { Translation } from '@/ui-kit/localization/locales/types';

const svSE: Translation = {
  loading: 'Läser in',
  progressBarCompleted: 'Färdig',
  progressBarCurrent: 'Nuvarande',
};

export default svSE;
